// import img from './../TeamHeader/coord-1.png'

export const Executive_Team = [
    {
        index: 0,
        image: "https://i.postimg.cc/gksqvRzV/raheena-bin-mohammed.png",
        name: "Raheena Bin Mohd.",
        post: "General Secratory",
        instaUrl: "https://www.instagram.com/raheenabini",
        linkdUrl: "https://www.linkedin.com/in/raheena-bin-mohammed-0aa646215/",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. dummy text of the printing and typesetting industry."
    },
    {
        index: 1,
        image: "https://i.postimg.cc/xTdDGvGY/vivek.png",
        name: "Vivek Pandey",
        post: "Asst. General Secratory",
        instaUrl: "https://www.instagram.com/y_wake_",
        linkdUrl: "https://www.linkedin.com/in/vivek-pandey-7ba66b217/",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. dummy text of the printing and typesetting industry."
    },
    {
        index: 2,
        image: "https://i.postimg.cc/Hsc95w4c/hrittika-hajari.png",
        name: "Hrittika Hajari",
        post: "Asst. General Secratory",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/hrittika-hajari-068972227/",
        description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. dummy text of the printing and typesetting industry."
    },
]

export const Social_Team = [
    {
        index: 0,
        image: "https://i.postimg.cc/9Q5j2fgK/tanmay-shree.png",
        name: "Tanmay Shree",
        post: "Lead",
        instaUrl: "https://www.instagram.com/tanmay_shree_25",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 1,
        image: "https://i.postimg.cc/2yYqsTDX/madhumita-moi-compressed.png",
        name: "Madhumita Moi",
        post: "Lead",
        instaUrl: "https://www.instagram.com/madhumitamoi",
        linkdUrl: "https://www.linkedin.com/in/madhumita-moi/",
    },
    {
        index: 2,
        image: "https://i.postimg.cc/8CJ86TSS/abhudhya-kumar.png",
        name: "Abhudhya Kumar",
        post: "Member",
        instaUrl: "https://www.instagram.com/abhudhya",
        linkdUrl: "https://www.linkedin.com/in/abhyuday-kumar-b1aa051a6/",
    },
    {
        index: 3,
        image: "https://i.postimg.cc/bY9tjXBy/rakshita.png",
        name: "Rakshita",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/rakshita-srivastava-58946b201/",
    },
    {
        index: 4,
        image: "https://i.postimg.cc/vZTv28Xx/triasha-roy.png",
        name: "Triasha Roy",
        post: "Member",
        instaUrl: "https://www.instagram.com/triashaaa.a",
        linkdUrl: "https://www.linkedin.com/in/triasharoy/",
    },
    {
        index: 5,
        image: "https://i.postimg.cc/Hsc95w4c/hrittika-hajari.png",
        name: "Hrittika Hajari",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/hrittika-hajari-068972227/",
    },
    {
        index: 6,
        image: "https://i.postimg.cc/4xp3gVWD/eshita-bhattacharjee.png",
        name: "Eshita Bhattacharjee",
        post: "Member",
        instaUrl: "https://www.instagram.com/eshi.bhatt",
        linkdUrl: "https://www.linkedin.com/in/eshita-bhattacharjee/",
    },
]



export const Editorial_Team = [
    {
        index: 0,
        image: "https://i.postimg.cc/rw3QdhtP/kajal.png",
        name: "Kajal Kumari",
        post: "Lead",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/kajalk14/",
    },
    {
        index: 1,
        image: "https://i.postimg.cc/4xp3gVWD/eshita-bhattacharjee.png",
        name: "Eshita Bhattacharjee",
        post: "Lead",
        instaUrl: "https://www.instagram.com/eshi.bhatt",
        linkdUrl: "https://www.linkedin.com/in/eshita-bhattacharjee/",
    },
    {
        index: 2,
        image: "https://i.postimg.cc/Hsc95w4c/hrittika-hajari.png",
        name: "Hrittika Hajari",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/hrittika-hajari-068972227/",
    },
    {
        index: 3,
        image: "https://i.postimg.cc/3NCFDd1W/dayita-chaudhuri.png",
        name: "Dayita Chaudhuri",
        post: "Lead",
        instaUrl: "https://www.instagram.com/doyit_aaaa",
        linkdUrl: "https://www.linkedin.com/in/dayita-chaudhuri/",
    },
    {
        index: 4,
        image: "https://i.postimg.cc/Dy42FLC2/sourajita-chanda.png",
        name: "Sourajita Chanda",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/sourajita-chanda-790a52200/",
    },
    {
        index: 5,
        image: "https://i.postimg.cc/136wggzS/akshit-parikh.png",
        name: "Akshit Parikh",
        post: "Member",
        instaUrl: "https://www.instagram.com/psi_phi__",
        linkdUrl: "https://www.linkedin.com/in/akshit-parikh-223b521b7/",
    },
    {
        index: 6,
        image: "https://i.postimg.cc/02gcVKB6/siddharthan-dileep.png",
        name: "Siddharthan Dileep",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/siddharthan-dileep-a513951b9/",
    },
    {
        index: 7,
        image: "https://i.postimg.cc/NMcjN4mJ/isha-tripathi.png",
        name: "Isha Tripathi",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/ishatri/",
    },
    {
        index: 8,
        image: "https://i.postimg.cc/6QmdyT2L/m-mahesh.png",
        name: "M. Mahesh",
        post: "Member",
        instaUrl: "https://www.instagram.com/itz_alpha_25",
        linkdUrl: "#",
    },
    {
        index: 9,
        image: "https://i.postimg.cc/8cW8qQGL/advait-girap.png",
        name: "Advait Girap",
        post: "Member",
        instaUrl: "https://www.instagram.com/advait.v.g",
        linkdUrl: "https://www.linkedin.com/in/advait-girap-380a20201/",
    },
    {
        index: 10,
        image: "https://i.postimg.cc/vZTv28Xx/triasha-roy.png",
        name: "Triasha Roy",
        post: "Member",
        instaUrl: "https://www.instagram.com/triashaaa.a",
        linkdUrl: "https://www.linkedin.com/in/triasharoy/",
    },
    {
        index: 11,
        image: "https://i.postimg.cc/nhr2zKsP/v-anjura.png",
        name: "Anjura Vundi",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/anjura-vundi-4b4918201/",
    },
    {
        index: 12,
        image: "https://i.postimg.cc/WbgF7hB1/sreyashi-das.png",
        name: "Shreyashi Das",
        post: "Member",
        instaUrl: "https://www.instagram.com/sreyashidas_",
        linkdUrl: "#",
    },
]


export const Graphics_Team = [
    {
        index: 0,
        image: "https://i.postimg.cc/KjyFcvJ0/aman-priyadarshi.png",
        name: "Aman Priyadarshi",
        post: "Graphics Lead",
        instaUrl: "https://www.instagram.com/aman__priyadarshi__",
        linkdUrl: "https://www.linkedin.com/in/aman-priyadarshi-248908204/",
    },
    {
        index: 1,
        image: "https://i.postimg.cc/s2N7Nbwj/akshat-kumar-verma.png",
        name: "Akshat Verma",
        post: "Technical Lead",
        instaUrl: "https://www.instagram.com/akshatk_verma",
        linkdUrl: "https://www.linkedin.com/in/akshatkumarverma/",
    },
    {
        index: 2,
        image: "",
        name: "Ankit Gautam",
        post: "Member",
        instaUrl: "https://www.instagram.com/someone___404",
        linkdUrl: "https://www.linkedin.com/in/theankitgautam/",
    },
    {
        index: 3,
        image: "https://i.postimg.cc/9Q5j2fgK/tanmay-shree.png",
        name: "Tanmay Shree",
        post: "Member",
        instaUrl: "https://www.instagram.com/tanmay_shree_25",
        linkdUrl: "https://www.linkedin.com/in/tanmayshree/",
    },
    {
        index: 4,
        image: "https://i.postimg.cc/zvtyyg6J/tirthankar-acharya.png",
        name: "Tirthankar Acharya",
        post: "Member",
        instaUrl: "https://www.instagram.com/tirthankar_acharya_02",
        linkdUrl: "https://www.linkedin.com/in/tirthankar-acharya-a42927218/",
    },
]


export const Debating_Team = [
    {
        index: 0,
        image: "https://i.postimg.cc/xTdDGvGY/vivek.png",
        name: "Vivek Pandey",
        post: "Lead",
        instaUrl: "https://www.instagram.com/y_wake_",
        linkdUrl: "https://www.linkedin.com/in/vivek-pandey-7ba66b217/",
    },
    {
        index: 1,
        image: "https://i.postimg.cc/gksqvRzV/raheena-bin-mohammed.png",
        name: "Raheena Bin Mohd.",
        post: "Technical Lead",
        instaUrl: "https://www.instagram.com/raheenabini",
        linkdUrl: "https://www.linkedin.com/in/raheena-bin-mohammed-0aa646215/",
    },
    {
        index: 2,
        image: "https://i.postimg.cc/vZTv28Xx/triasha-roy.png",
        name: "Triasha Roy",
        post: "Member",
        instaUrl: "https://www.instagram.com/triashaaa.a",
        linkdUrl: "https://www.linkedin.com/in/triasharoy/",
    },
    {
        index: 3,
        image: "https://i.postimg.cc/YSrjz87p/dharun-shankar.png",
        name: "Dharun Shankar",
        post: "Member",
        instaUrl: "https://www.instagram.com/dharun_shankarr8",
        linkdUrl: "https://www.linkedin.com/in/dharun-shankar/",
    },
    {
        index: 4,
        image: "https://i.postimg.cc/NMcjN4mJ/isha-tripathi.png",
        name: "Isha Tripathi",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/ishatri/",
    },
    {
        index: 5,
        image: "https://i.postimg.cc/rw3QdhtP/kajal.png",
        name: "Kajal Kumari",
        post: "Member",
        instaUrl: "#",
        linkdUrl: "https://www.linkedin.com/in/kajalk14/",
    },
    {
        index: 6,
        image: "https://i.postimg.cc/136wggzS/akshit-parikh.png",
        name: "Akshit Parikh",
        post: "Member",
        instaUrl: "https://www.instagram.com/psi_phi__",
        linkdUrl: "https://www.linkedin.com/in/akshit-parikh-223b521b7/",
    },
    {
        index: 7,
        image: "https://i.postimg.cc/8cW8qQGL/advait-girap.png",
        name: "Advait Girap",
        post: "Member",
        instaUrl: "https://www.instagram.com/advait.v.g",
        linkdUrl: "https://www.linkedin.com/in/advait-girap-380a20201/",
    },
    {
        index: 8,
        image: "https://i.postimg.cc/zfVzXf1r/sumit-kumar.png",
        name: "Sumit Kumar",
        post: "Member",
        instaUrl: "https://www.instagram.com/s_sumit_9",
        linkdUrl: "https://www.linkedin.com/in/sumit-kumar-3233181aa/",
    },
]